import { render } from "./Catalogsearch.vue?vue&type=template&id=abba3bf4"
import script from "./Catalogsearch.vue?vue&type=script&lang=js"
export * from "./Catalogsearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__